/**
 * Lightweight logger — emits to console only in development.
 * In production builds (`NODE_ENV === 'production'`), all methods are no-ops
 * so we don't leak operational noise to end users while keeping useful
 * diagnostics during development.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
